import * as v from "valibot";
import { rpcContract } from "../rpc";
import { exclusiveHighlightV1CustomizationSchema } from "./save-email-customization";

export const getEmailCustomizationRpcContract = rpcContract({
  name: "get-email-customization",
  paramsSchema: v.object({
    linkId: v.pipe(v.string("linkId must be a string"), v.uuid("Invalid linkId: must be a valid UUID")),
    influencer_id: v.pipe(
      v.string("influencerId must be a string"),
      v.uuid("Invalid influencerId: must be a valid UUID (e.g., 123e4567-e89b-12d3-a456-426614174000)"),
    ),
  }),
  resultSchema: v.object({
    customization: v.optional(exclusiveHighlightV1CustomizationSchema),
  }),
});

export type GetEmailCustomizationParams = v.InferOutput<(typeof getEmailCustomizationRpcContract)["paramsSchema"]>;
export type GetEmailCustomizationResult = v.InferOutput<(typeof getEmailCustomizationRpcContract)["resultSchema"]>;
export type EmailCustomization = v.InferOutput<
  (typeof getEmailCustomizationRpcContract)["resultSchema"]
>["customization"];
